import { mergeClasses } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../constants';
import { FloatingButton } from './floating-button';
import { FloatingDataChip } from './floating-data-chip';
import { FloatingTool } from './floating-tool';
import { getPositionStyles } from './get-position-styles';
import { Position } from './types';

type Props = {
  children: React.ReactNode;
  className?: string;
  disableResponsiveness?: boolean;
  position?: Position;
};

export const FloatingToolbar = ({
  children,
  className,
  disableResponsiveness = false,
  position = 'top-left',
}: Props) => (
  <div
    css={[
      getPositionStyles(position),
      {
        '.composer-section.unselected &': {
          display: 'none',
        },
        svg: {
          flexShrink: 0,
        },
      },
      !disableResponsiveness && {
        [`@media (max-width: ${COMPOSER_BREAKPOINTS.MOBILE}px)`]: {
          display: 'none',
        },
      },
    ]}
    className={mergeClasses('floating-toolbar', position, className)}
  >
    {children}
  </div>
);

FloatingToolbar.Button = FloatingButton;
FloatingToolbar.DataChip = FloatingDataChip;
FloatingToolbar.Tool = FloatingTool;
